import { LoginGate } from './components/LoginGate'
import { PromptPanel } from './components/PromptPanel'
import { ConfigPanel } from './components/ConfigPanel'
import { AccountPanel } from './components/AccountPanel'
import { GitHubPanel } from './components/GitHubPanel'
import { WorkspacePanel } from './components/WorkspacePanel'
import { MetricsCard } from './components/MetricsCard'
import { PrdViewer } from './components/PrdViewer'
import { OutputTerminal } from './components/OutputTerminal'
import { StatusBar } from './components/StatusBar'
import { ActionBar } from './components/ActionBar'
import './styles/global.css'

export function App() {
  return (
    <LoginGate>
      <div className="app">
        <header className="app-header">
          <div className="header-left">
            <span className="header-logo">Enclosed Ralph</span>
            <span className="header-divider" />
            <span className="header-branch">cloud mission control</span>
          </div>
          <StatusBar />
        </header>

        <main className="app-main">
          <div className="left-column">
            <PromptPanel />
            <PrdViewer />
            <AccountPanel />
            <ConfigPanel />
            <GitHubPanel />
            <WorkspacePanel />
            <MetricsCard />
            <ActionBar />
          </div>

          <div className="right-column">
            <OutputTerminal />
          </div>
        </main>
      </div>
    </LoginGate>
  )
}
